<table class="subwindow" [cdkDragConstrainPosition]="constrainPosition" plessTitleWindowSub cdkDrag [windowMovable]="false" [windowResizable]="false"
  [frontDispFlag]="true">
  <tr class="subwindow-title" cdkDragHandle>
    <th class="window-title-name">処理ログ</th>
    <!-- ダイアログ閉じるボタンを最後にフォーカスしたいため最後方に移動済 -->
  </tr>
  <tr class="subwindow-body">
    <td>
      <div class="contents-area" (dragstart)="onDragstartBody($event)">
        <div>
          <wj-flex-grid #dtg_LogList [itemsSource]="kymw0D00Model.logList" id="dtg_LogList" [style.width.px]="1320"
            [style.height.px]="773" [isReadOnly]="true" [deferResizing]="true" [headersVisibility]="'Column'"
            [allowDragging]="'None'" [allowSorting]="false" [selectionMode]="'Row'" [tabindex]="0"
            forcedEnabledMode="true">
            <wj-flex-grid-column [minWidth]="5" [header]="kymw0D00Model.headerText0" [width]="80" [binding]="'InfoKind'"
              [align]="'left'">
            </wj-flex-grid-column>
            <wj-flex-grid-column [minWidth]="5" [header]="kymw0D00Model.headerText1" [width]="80" [binding]="'LineNo'"
              [align]="'right'">
            </wj-flex-grid-column>
            <wj-flex-grid-column [minWidth]="5" [header]="kymw0D00Model.headerText2" [width]="180" [binding]="'DataKind'"
              [align]="'left'">
            </wj-flex-grid-column>
            <wj-flex-grid-column [minWidth]="5" [header]="kymw0D00Model.headerText3" [width]="130"
              [binding]="'ProcessResult'" [align]="'left'">
              <ng-template wjFlexGridCellTemplate [cellType]="'Cell'" let-cell="cell">
                <label [class.result-color-error]="cell.item.ProcessResult === '中断'
                || cell.item.ProcessResult === '異常'
                || cell.item.ProcessResult === 'エラー発生'">
                  {{cell.item.ProcessResult}}</label>
              </ng-template>
            </wj-flex-grid-column>
            <wj-flex-grid-column [minWidth]="5" [header]="kymw0D00Model.headerText4" [width]="830" [binding]="'Contents'"
              [align]="'left'">
              <ng-template wjFlexGridCellTemplate [cellType]="'Cell'" let-cell="cell">
                <label [style.width.%]="100" [style.text-align]="'left'"
                  [style.position]="'relative'">{{cell.item.Contents}}</label>
              </ng-template>
            </wj-flex-grid-column>
          </wj-flex-grid>
        </div>
      </div>
    </td>
  </tr>

  <tfoot cdkDragHandle>
    <tr>
      <td>
        <div class="footer-buttons">
          <button id="btn_Output" class="btn-primary" #btn_Output forcedEnabledMode="none"
            (click)="eventOutput_CLICKHandler(null)" [tabindex]="0">出力</button>
        </div>
        <div class="window-title-close">
          <!-- ダイアログ閉じるボタンを最後にフォーカスしたいため最後方に移動済 -->
          <button [tabindex]="0" (click)="eventCloseWindow_ClickHandler(null)"></button>
        </div>
    </tr>
  </tfoot>
</table>